import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';

export function runForesterTick(settlement: Settlement): boolean {
    if (settlement.jobs.foresters <= 0) return false;
    const ticksPerTree = getGameConfig().production.forester.ticksPerTree;
    if (!Number.isFinite(ticksPerTree) || ticksPerTree <= 0) return false;

    if (!settlement.production.ecology) return false;
    let changed = false;

    const cap = settlement.regionResources.canopyCap;
    if (cap > 0) {
        const total = settlement.regionResources.trees.reduce(
            (sum, entry) => sum + entry.amount,
            0,
        );
        if (total >= cap) {
            if (settlement.production.ecology.foresterTick !== 0) {
                settlement.production.ecology.foresterTick = 0;
                return true;
            }
            return false;
        }
    }

    const prev = settlement.production.ecology.foresterTick || 0;
    settlement.production.ecology.foresterTick = prev + settlement.jobs.foresters;

    if (settlement.production.ecology.foresterTick >= ticksPerTree) {
        const grown = Math.floor(settlement.production.ecology.foresterTick / ticksPerTree);
        settlement.production.ecology.foresterTick -= grown * ticksPerTree;
        if (grown > 0) {
            const bucket = settlement.regionResources.trees.find((entry) => entry.age === 0);
            if (bucket) {
                bucket.amount += grown;
            } else {
                settlement.regionResources.trees.push({ age: 0, amount: grown });
            }
            changed = true;
        }
    }

    return changed;
}
